export default __webpack_public_path__ + "static/media/work-step-1.a4962252.png";